import React from 'react'
import ReactTooltip from 'react-tooltip'
import { CustomInfoTooltip } from 'src/components/CustomInfoTooltip'
import './InfoBox.scss'

export interface Info {
  property: string
  tooltip?: string
  value: string | JSX.Element
}

interface IProps {
  infos: Info[]
}

export function InfoBox({ infos }: IProps) {
  return (
    <div className="info-box">
      <ReactTooltip multiline id="info-box" />
      {infos.map(({ property, tooltip, value }, index) => (
        <div key={property || index} className="info-box__row">
          <div className="info-box__row-property">
            <span>{property}</span>
            {tooltip && (
              <span className="info-box__tooltip">
                <CustomInfoTooltip forId="info-box" place="top" description={tooltip} />
              </span>
            )}
          </div>
          <div className="info-box__row-value">{value}</div>
        </div>
      ))}
    </div>
  )
}
